import React, { Component } from 'react'

export default class AddExpense extends Component {
  render() {
    return (
      <div>AddExpense</div>
    )
  }
}
